import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';
import { Logo, FullLogoWidth } from './Logo';

interface IPrintHeaderProps {}

export const PrintHeader: FC<IPrintHeaderProps> = () => {
  const classes = useStyles();
  return (
    <Box className={classes.printHeader}>
      <Logo className={ classes.logo } />
    </Box>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => {
  return {
    printHeader: {
      display: 'none',
      '@media print': {
        display: 'block',
        margin: theme.spacing(1, 0, 0.5, 0),
        paddingBottom: theme.spacing(1),
        textAlign: 'center',
        borderBottom: `1px solid ${theme.palette.grey[300]}`
      }
    },
    logo: {
      maxWidth: FullLogoWidth
    }
  };
});
